import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import { Button } from "react-bootstrap";
import Translate from "src/components/Translate";
import constants from "src/constants";
import Add_event from "src/icons/Add-event";
import Download from "src/icons/Download";
import Facebook from "src/icons/Facebook";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";

type Props = {
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
};

function PublishButtons({ className, style }: Props) {
  return constants.Show.navPublishButtons ? (
    <div
      style={style}
      className={composeClassNames([sButtons, className, "publish-buttons"])}
    >
      <Button
        variant="outline-primary"
        className={composeClassNames([sButton, "btn-icon-before"])}
      >
        <Facebook />
        <Translate tKey={`Share on Facebook`} />
      </Button>
      <Button
        variant="outline-primary"
        className={composeClassNames([sButton, "btn-icon-before"])}
      >
        <Add_event />
        <Translate tKey={`Add to Calendar`} />
      </Button>
      {constants.Show.contentOfflineStorage ? (
        <Button
          variant="outline-primary"
          className={composeClassNames([sButton, "btn-icon-before"])}
        >
          <Download />
          <Translate tKey={`Download to Off-line`} />
        </Button>
      ) : null}
    </div>
  ) : null;
}

export default PublishButtons;
